var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSortingTableArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 7,
    viewBox: "0 0 6 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5655 0.79875C3.5945 0.83171 3.7185 0.956162 3.8205 1.07209C4.462 1.75175 5.512 3.52476 5.8325 4.45275C5.884 4.59368 5.993 4.94999 6 5.14036C6 5.32278 5.964 5.49667 5.891 5.66261C5.789 5.86946 5.6285 6.0354 5.439 6.12632C5.3075 6.18485 4.914 6.27578 4.907 6.27578C4.4765 6.3667 3.777 6.41671 3.004 6.41671C2.2675 6.41671 1.5965 6.3667 1.1595 6.29226C1.1525 6.28373 0.6635 6.19281 0.496 6.09336C0.19 5.91094 0 5.55464 0 5.17332L0 5.14036C0.0075 4.89203 0.1975 4.36978 0.2045 4.36978C0.5255 3.4918 1.524 1.7597 2.1875 1.06357C2.1875 1.06357 2.358 0.867511 2.4645 0.78227C2.6175 0.649294 2.807 0.583374 2.9965 0.583374C3.208 0.583374 3.405 0.657818 3.5655 0.79875Z",
    fill: "#D1D1D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortingTableArrow);
export default __webpack_public_path__ + "static/media/icon-sorting-table-arrow.ae4488f7b5ec54f8709e11c0d044aede.svg";
export { ForwardRef as ReactComponent };